import { useCallback } from 'react';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';
import { getRequestContext } from '@/shared/lib/requestContext';

export const StockChangedModal = (props: AlertProps) => {
    const { host } = getRequestContext();

    const onHomeClick = useCallback(() => {
        if (host.startsWith('http://') || host.startsWith('https://')) {
            window.location.href = host;
        } else {
            window.location.href = `https://${host}`;
        }
    }, [host]);

    return (
        <Alert
            {...props}
            title="Товара нет в наличии"
            description="Весь товар раскупили. Перейдите в магазин, чтобы увидеть другие предложения продавца."
            button={
                <DrawerBottomFixed>
                    <DrawerButton onClick={onHomeClick}>В магазин</DrawerButton>
                </DrawerBottomFixed>
            }
        />
    );
};
